<script>
export default {
    name: 'BaseTimePickerHours',
};
</script>

<script setup>
import { computed } from 'vue';
import { HOURS_FORMAT, TYPE } from '@/components/base-components/components/time-picker/index.js';
import BaseTimePickerPicker from '@/components/base-components/components/time-picker/components/picker.vue';
import { getHours } from '@/components/base-components/components/time-picker/utils/helpers.js';

const props = defineProps({
    value:       {
        type: Date,
    },
    hoursFormat: {
        type:      String,
        default:   HOURS_FORMAT.HOURS_24,
        validator: value => Object.values(HOURS_FORMAT).includes(value),
    },
    type:  {
        type:      String,
        default:   TYPE.DEFAULT,
        validator: value => Object.values(TYPE).includes(value),
    },
});

const emit = defineEmits({
    input: null,
});

const model = computed({
    get: () => {
        const hours = (props.value ?? new Date()).getHours();

        if (props.hoursFormat === HOURS_FORMAT.HOURS_24) return hours;

        return hours >= 12 ? hours - 12 : hours;
    },
    set: (value) => {
        const date = new Date(props.value ?? new Date());

        const currentHours = date.getHours();

        if (props.hoursFormat === HOURS_FORMAT.HOURS_12) {
            const adjustedHours = currentHours >= 12 ? (value % 12) + 12 : value % 12;

            date.setHours(adjustedHours);
        } else {
            date.setHours(value);
        }

        emit('input', date);
    },
});
</script>

<template>
    <base-time-picker-picker
        v-model="model"
        :items="getHours(hoursFormat)"
        :type="type"
    />
</template>
